import { CLINICAL_ITEM_TYPE_TO_TEXT as CLINICAL_ITEM_TYPE_TO_TEXT_COMMON } from '@features/components/ClinicalData/constants';
import { ClinicalItemType } from '@/api/apis/case';

export const CLINICAL_ITEM_TYPE_TO_TEXT: Record<ClinicalItemType, string> = {
  ...CLINICAL_ITEM_TYPE_TO_TEXT_COMMON,
  [ClinicalItemType.FinalPhysicalExamPictureOrVideo]: 'Final physical exam picture or video',
  [ClinicalItemType.FinalBronchVideoAtTheRecipientHospital]: 'Final Bronch Video at the Recipient Hospital',
  [ClinicalItemType.RecordDelay]: 'Record a delay',
  [ClinicalItemType.PFRatioOnOCSTXCenter]: 'PF ratio on the OCS at recipient hospital',
};

// Clinical items recorded at or after OrganOnOCS.
export const POST_ORGAN_ON_OCS_CLINICAL_ITEM_TYPES: ClinicalItemType[] = [
  ClinicalItemType.LeavingDonorHospital,
  ClinicalItemType.ArrivalAtRecipientHospital,
  ClinicalItemType.OffOCS,
  ClinicalItemType.OffSCS,
  ClinicalItemType.LeavingRecipientHospital,
  ClinicalItemType.SpecialistIsDone,
  ClinicalItemType.OffOCSPhotoAndVideo,
  ClinicalItemType.FinalBronchVideoAtTheRecipientHospital,
  ClinicalItemType.FinalPhysicalExamPictureOrVideo,
  ClinicalItemType.PFRatioOnOCSTXCenter,
  ClinicalItemType.TxOCSBiopsy,
  ClinicalItemType.ServiceConfirmation,
  ClinicalItemType.PerfusionTerminationOption,
  ClinicalItemType.ScsTerminationOption,
  ClinicalItemType.DiscardConfirmationForm,
];
